<template>
    <input
        type="radio"
        :id="id"
        :name="name"
        :checked="checked"
        :aria-label="ariaLabel"
        autocomplete="off"
        class="base-radio"
        @change="$emit('change', $event)"
    />
</template>

<script>
export default {
	name: 'CieloInputRadio',

	props: {
		id: {
			type: String,
			required: true
		},
		name: {
			type: String,
			default: ''
		},
		checked: {
			type: Boolean,
			default: false
		},
		ariaLabel: {
			type: String,
			default: ''
		}
	},
};
</script>

<style scoped>
.base-radio {
  appearance: none;
  width: 24px;
  height: 24px;
  border: 2px solid #5C6A7B;
  border-radius: 50%;
  background-color: #FFFFFF;
  position: relative;
  outline: none;
  transition: border-color 0.2s ease;
  cursor: pointer;
}
.base-radio:checked {
  border: 5px solid #0774E7;
}
</style>
